import script from "./FacilitatorsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./FacilitatorsTable.vue?vue&type=script&lang=ts&setup=true"

import "./FacilitatorsTable.vue?vue&type=style&index=0&id=49c6e594&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c6e594"]])

export default __exports__